import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { RayDataConstant } from './constants/RayDataConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';

// IMP-372: 동일 type+baseDate standards 가 복수(여러 seq)일 때 seq 최댓값 항목의 months 를 반환.
// 매칭 없으면 undefined (기존 .find()?.months 시맨틱 보존 — 호출부의 || '' 로 폴백).
const monthsByMaxSeq = (standards, type, baseDate) => {
	if (!Array.isArray(standards)) return undefined;
	const matched = standards.filter(y => y?.type === type && y?.baseDate === baseDate);
	if (matched.length === 0) return undefined;
	return matched.reduce((a, b) => ((b?.seq ?? 0) > (a?.seq ?? 0) ? b : a))?.months;
};

const GetAll = (dataType, companyId = '') => async (dispatch) => {
	dispatch({ type: RayDataConstant.LOADING });

	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/raydata/' + dataType, JWT());

		if (ret.data.status == 'success') {
			let result = [];

			if (companyId) {
				let companyIdList = [];
				// IMP-271: getchildren 실패는 warranty 전체 실패로 간주하지 않고 빈 목록 폴백.
				try {
					const response = await axios.get(`${AppConfig.API_SERVER_PATH}/company/getchildren/${companyId}`, JWT());
					if (response.data.status === 'success') {
						if (Array.isArray(response.data.data)) {
							companyIdList = response.data.data;
						} else {
							// IMP-271 (review): success 이지만 data 가 비배열(malformed) → 빈 목록 폴백 (격리 유지)
							console.warn('[RayDataAction.GetAll] getchildren non-array data — empty fallback', {
								handler: 'RayDataAction.GetAll',
								companyId,
								reason: 'getchildren success payload data is not an array',
							});
						}
					} else {
						console.warn('[RayDataAction.GetAll] getchildren non-success — empty fallback', {
							handler: 'RayDataAction.GetAll',
							companyId,
							status: response.data.status,
							reason: response.data.err || 'getchildren returned non-success',
						});
					}
				} catch (childErr) {
					console.warn('[RayDataAction.GetAll] getchildren failed — empty fallback', {
						handler: 'RayDataAction.GetAll',
						companyId,
						status: childErr?.response?.status,
						reason: childErr?.message || String(childErr),
					});
					companyIdList = [];
				}

				if (companyIdList.length){
					result = ret.data.data.filter(x => companyIdList.includes(x.companyId) && x.hasOwnProperty('category') && x.hasOwnProperty('standards'));
				}
			} else {
				result = ret.data.data.filter(x=> x.hasOwnProperty('category') && x.hasOwnProperty('standards'));
			}


			const items = [];

			result.forEach(x => {
				//const exists = items.find(y => y.companyId === x.companyId && y.warrantyType === x.wartype && y.models === y.models);
				const exists = items.find(y => y.companyId === x.companyId && y.warrantyType === x.wartype && (y.models.every(md => x.models.includes(md)) && x.models.every(md => y.models.includes(md))));

				if (!exists || !Object.keys(exists).length) {
					items.push({
						_id: x._id,
						companyId: x.companyId,
						category: x.category,
						warrantyType: x.wartype,
						wartype: x.wartype,
						models: x.models,
						standards : x.standards,

						hqId: x.category === "HQ" ? x._id : '',
						hqStandards: x.category === "HQ" ? x.standards : null,
						branchId: x.category === "BRANCH" ? x._id : '',
						branchStandards: x.category === "BRANCH" ? x.standards : null,

						productWarrantyByInstalledDateHQ: x.category === "HQ" ? monthsByMaxSeq(x.standards, "Product", "InstalledDate") : '',
						productWarrantyByShipmentDateHQ: x.category === "HQ" ? monthsByMaxSeq(x.standards, "Product", "ShipmentDate") : '',
						mainPartsWarrantyByInstalledDateHQ: x.category === "HQ" ? monthsByMaxSeq(x.standards, "MainParts", "InstalledDate") : '',
						mainPartsWarrantyByShipmentDateHQ: x.category === "HQ" ? monthsByMaxSeq(x.standards, "MainParts", "ShipmentDate") : '',

						productWarrantyByInstalledDateBranch: x.category === "BRANCH" ? monthsByMaxSeq(x.standards, "Product", "InstalledDate") : '',
						productWarrantyByShipmentDateBranch: x.category === "BRANCH" ? monthsByMaxSeq(x.standards, "Product", "ShipmentDate") : '',
						mainPartsWarrantyByInstalledDateBranch: x.category === "BRANCH" ? monthsByMaxSeq(x.standards, "MainParts", "InstalledDate") : '',
						mainPartsWarrantyByShipmentDateBranch: x.category === "BRANCH" ? monthsByMaxSeq(x.standards, "MainParts", "ShipmentDate") : '',
					});
				} else {
					if (x.category === 'HQ') {
						exists.hqId = x._id;
						exists.hqStandards = x.standards;
						exists["productWarrantyByInstalledDateHQ"] = monthsByMaxSeq(x.standards, "Product", "InstalledDate") || '';
						exists["productWarrantyByShipmentDateHQ"] = monthsByMaxSeq(x.standards, "Product", "ShipmentDate") || '';
						exists["mainPartsWarrantyByInstalledDateHQ"] = monthsByMaxSeq(x.standards, "MainParts", "InstalledDate") || '';
						exists["mainPartsWarrantyByShipmentDateHQ"] = monthsByMaxSeq(x.standards, "MainParts", "ShipmentDate") || '';
					}

					if (x.category === 'BRANCH') {
						exists.branchId = x._id;
						exists.branchStandards = x.standards;
						exists["productWarrantyByInstalledDateBranch"] = monthsByMaxSeq(x.standards, "Product", "InstalledDate") || '';
						exists["productWarrantyByShipmentDateBranch"] = monthsByMaxSeq(x.standards, "Product", "ShipmentDate") || '';
						exists["mainPartsWarrantyByInstalledDateBranch"] = monthsByMaxSeq(x.standards, "MainParts", "InstalledDate") || '';
						exists["mainPartsWarrantyByShipmentDateBranch"] = monthsByMaxSeq(x.standards, "MainParts", "ShipmentDate") || '';
					}
				}
			});

			dispatch({ type: RayDataConstant.GETALL, items });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		console.warn('[RayDataAction.GetAll] failed', { dataType, companyId, status: error?.response?.status, reason: error?.message || String(error) });
		dispatch(AlertAction.ErrorMsg("Failed to load warranty data."));
	} finally {
		dispatch({ type: RayDataConstant.LOADED });
	}
};

const GetAllByFilter = async (datatype, filter) => {
	try {
		const data = {
			type: 'getfilter',
			data: filter,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/raydata/' + datatype, data, JWT());
		if (ret.data.status == 'success') {
			return ret.data.data;
		} else {
			console.warn('[RayDataAction.GetAllByFilter] non-success', {
				handler: 'RayDataAction.GetAllByFilter',
				target: datatype,
				reason: 'status != success',
			});
			return [];
		}
	} catch (error) {
		console.warn('[RayDataAction.GetAllByFilter] failed', {
			handler: 'RayDataAction.GetAllByFilter',
			target: datatype,
			reason: error?.message || String(error),
		});
		return [];
	}
};

const GetOne = (datatype, _id) => async (dispatch) => {
	dispatch({ type: RayDataConstant.LOADING });
	const ret = await axios.get(AppConfig.API_SERVER_PATH + '/raydata/' + datatype + '/' + _id, JWT());
	if (ret.data.status == 'success') {
		dispatch({ type: RayDataConstant.GET, item: ret.data.data });
	} else {
		dispatch(AlertAction.Error(ret.data));
	}
	dispatch({ type: RayDataConstant.LOADED });
};

const Delete = (datatype, _id) => async (dispatch) => {
	dispatch({ type: RayDataConstant.LOADING });
	const data = {
		type: 'delete',
	};
	const ret = await axios.post(AppConfig.API_SERVER_PATH + '/raydata/' + datatype + '/' + _id, data, JWT());
	if (ret.data.status == 'success') {
		dispatch(AlertAction.Success(t('common.message.deleted')));
		dispatch({ type: RayDataConstant.DELETE, _id: _id });
	} else {
		dispatch(AlertAction.Error(ret.data));
	}
	dispatch({ type: RayDataConstant.LOADED });
};

const Create = (datatype, info) => async (dispatch) => {
	dispatch({ type: RayDataConstant.LOADING });
	try {
		const data = {
			type: 'create',
			data: info,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/raydata/' + datatype, data, JWT());
		if (ret.data.status == 'success') {
			const data = ret.data.data;

			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({
				type: RayDataConstant.CREATE,
				item: {
					...data,
					warrantyType: data.wartype,
					productWarrantyByInstalledDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "Product", "InstalledDate") : '',
					productWarrantyByShipmentDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "Product", "ShipmentDate") : '',
					mainPartsWarrantyByInstalledDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "MainParts", "InstalledDate") : '',
					mainPartsWarrantyByShipmentDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "MainParts", "ShipmentDate") : '',
					productWarrantyByInstalledDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "Product", "InstalledDate") : '',
					productWarrantyByShipmentDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "Product", "ShipmentDate") : '',
					mainPartsWarrantyByInstalledDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "MainParts", "InstalledDate") : '',
					mainPartsWarrantyByShipmentDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "MainParts", "ShipmentDate") : '',
				},
			});
			return { status: 'success', data: ret.data.data };
		} else {
			dispatch(AlertAction.Error(ret.data));
			return { status: 'fail', reason: ret.data?.errmsg || ret.data?.err };
		}
	} catch (error) {
		console.warn('[RayDataAction.Create] failed', { handler: 'RayDataAction.Create', target: datatype, status: error?.response?.status, reason: error?.message || String(error) });
		dispatch(AlertAction.Error(error));
		return { status: 'fail', reason: error?.response?.data?.data?.reason || error?.message };
	} finally {
		dispatch({ type: RayDataConstant.LOADED });
	}
};

const AddUpdate = (info) => async (dispatch) => {
	dispatch({ type: RayDataConstant.ADDUPDATE, item: info });
};

const Update = (datatype, _id, info) => async (dispatch) => {
	dispatch({ type: RayDataConstant.LOADING });
	try {
		const data = {
			type: 'update',
			data: info,
		};
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/raydata/' + datatype + '/' + _id, data, JWT());
		if (ret.data.status == 'success') {
			const data = ret.data.data;

			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({
				type: RayDataConstant.UPDATE,
				item: {
					...data,
					warrantyType: data.wartype,
					productWarrantyByInstalledDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "Product", "InstalledDate") : '',
					productWarrantyByShipmentDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "Product", "ShipmentDate") : '',
					mainPartsWarrantyByInstalledDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "MainParts", "InstalledDate") : '',
					mainPartsWarrantyByShipmentDateHQ: data.category === "HQ" ? monthsByMaxSeq(data.standards, "MainParts", "ShipmentDate") : '',
					productWarrantyByInstalledDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "Product", "InstalledDate") : '',
					productWarrantyByShipmentDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "Product", "ShipmentDate") : '',
					mainPartsWarrantyByInstalledDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "MainParts", "InstalledDate") : '',
					mainPartsWarrantyByShipmentDateBranch: data.category === "BRANCH" ? monthsByMaxSeq(data.standards, "MainParts", "ShipmentDate") : '',
				}
			});
			return { status: 'success', data: ret.data.data };
		} else {
			dispatch(AlertAction.Error(ret.data));
			return { status: 'fail', reason: ret.data?.errmsg || ret.data?.err };
		}
	} catch (error) {
		console.warn('[RayDataAction.Update] failed', { handler: 'RayDataAction.Update', target: datatype, status: error?.response?.status, reason: error?.message || String(error) });
		dispatch(AlertAction.Error(error));
		return { status: 'fail', reason: error?.response?.data?.data?.reason || error?.message };
	} finally {
		dispatch({ type: RayDataConstant.LOADED });
	}
};

const SetWarranty = async (sn, category, warrantyType, preview = false) => {
	try {
		const ret = await axios.post(`${AppConfig.API_SERVER_PATH}/set-warranty`, { sn, category, warrantyType, preview }, JWT());
		return ret.data;
	} catch (error) {
		const httpStatus = error?.response?.status;
		const reason = error?.response?.data?.data?.reason || error?.response?.data?.errmsg;

		console.warn('[RayDataAction.SetWarranty] failed', { handler: 'RayDataAction.SetWarranty', target: sn, httpStatus, reason: reason || error?.message || String(error) });

		if (httpStatus) {
			return { status: 'fail', httpStatus, reason, data: [] };
		}

		return { status: 'fail', data: [] };
	}
}

const Preview = async (datatype, info) => {
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/raydata/' + datatype, { type: 'preview', data: info }, JWT());
		return ret.data;
	} catch (error) {
		const httpStatus = error?.response?.status;
		const reason = error?.response?.data?.data?.reason || error?.response?.data?.errmsg;
		console.warn('[RayDataAction.Preview] failed', { handler: 'RayDataAction.Preview', target: datatype, httpStatus, reason: reason || error?.message || String(error) });
		return { status: 'fail', httpStatus, reason };
	}
};

export const RayDataAction = {
	GetAll,
	GetOne,
	GetAllByFilter,
	Create,
	Update,
	Delete,
	AddUpdate,
	SetWarranty,
	Preview
};
